import { logger } from "../logger";
import CookieStorage from "./built-in/cookie";
import MemoryStorage from "./built-in/memory";
import WebStorage from "./built-in/web";
// Fallback as follows: cookieStorage, localStorage, sessionStorage, memoryStorage
var TYPES = [
    "cookieStorage",
    "localStorage",
    "sessionStorage",
    "memoryStorage",
];
var StorageManager = /** @class */ (function () {
    function StorageManager(writeKey) {
        this.writeKey = writeKey;
        this.storages = new Map();
    }
    StorageManager.prototype.getStorage = function (type) {
        if (!this.storages.has(type)) {
            var storage = this.createStorage(type);
            // If storage is not available, try next
            while (!storage.isAvailable()) {
                var index = TYPES.indexOf(type);
                logger.warn("Storage ".concat(type, " is not available, trying ").concat(TYPES[index + 1]));
                storage = this.createStorage(TYPES[index + 1]);
            }
            // Add to cache
            this.storages.set(type, storage);
        }
        return this.storages.get(type);
    };
    StorageManager.prototype.createStorage = function (type) {
        switch (type) {
            case "cookieStorage":
                return new CookieStorage(this.writeKey);
            case "localStorage":
                return new WebStorage(this.writeKey, localStorage);
            case "sessionStorage":
                return new WebStorage(this.writeKey, sessionStorage);
            case "memoryStorage":
            default:
                return new MemoryStorage(this.writeKey);
        }
    };
    return StorageManager;
}());
export { StorageManager };
//# sourceMappingURL=StorageManager.js.map